// Service Worker 管理器
class ServiceWorkerManager {
  constructor() {
    this.registration = null
    this.isSupported = 'serviceWorker' in navigator
  }

  // 註冊 Service Worker
  async register() {
    if (!this.isSupported) {
      console.warn('此瀏覽器不支援 Service Worker')
      return false
    }

    try {
      // 使用靜態的 Service Worker 檔案
      this.registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      })

      console.log('Service Worker 註冊成功:', this.registration.scope)

      // 監聽更新
      this.registration.addEventListener('updatefound', () => {
        console.log('發現 Service Worker 更新')
        const newWorker = this.registration.installing
        
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('新的 Service Worker 可用，請重新整理頁面')
            this.notifyUpdate()
          }
        })
      })

      // 監聽控制權變更
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('Service Worker 控制權已變更')
        window.location.reload()
      })

      return true
    } catch (error) {
      console.error('Service Worker 註冊失敗:', error)
      return false
    }
  }

  // 取消註冊 Service Worker
  async unregister() {
    if (this.registration) {
      const result = await this.registration.unregister()
      console.log('Service Worker 取消註冊:', result)
      return result
    }
    return false
  }

  // 檢查 Service Worker 狀態
  async getStatus() {
    if (!this.isSupported) {
      return { supported: false }
    }

    const registration = await navigator.serviceWorker.getRegistration()
    
    return {
      supported: true,
      registered: !!registration,
      active: !!registration?.active,
      waiting: !!registration?.waiting,
      installing: !!registration?.installing
    }
  }

  // 發送訊息給 Service Worker
  async sendMessage(message) {
    if (!navigator.serviceWorker.controller) {
      console.warn('沒有可用的 Service Worker')
      return null
    }

    return new Promise((resolve, reject) => {
      const messageChannel = new MessageChannel()
      
      messageChannel.port1.onmessage = (event) => {
        if (event.data.error) {
          reject(new Error(event.data.error))
        } else {
          resolve(event.data)
        }
      }

      navigator.serviceWorker.controller.postMessage(message, [messageChannel.port2])
    })
  }

  // 快取認證資料到 Service Worker
  async cacheAuthData(authData) {
    try {
      navigator.serviceWorker.controller?.postMessage({
        type: 'CACHE_AUTH_DATA',
        data: authData
      })
    } catch (error) {
      console.warn('無法快取認證資料到 Service Worker:', error)
    }
  }

  // 清除認證快取
  async clearAuthCache() {
    try {
      navigator.serviceWorker.controller?.postMessage({
        type: 'CLEAR_AUTH_CACHE'
      })
    } catch (error) {
      console.warn('無法清除 Service Worker 認證快取:', error)
    }
  }

  // 取得快取狀態
  async getCacheStatus() {
    try {
      return await this.sendMessage({ type: 'GET_CACHE_STATUS' })
    } catch (error) {
      console.warn('無法取得 Service Worker 快取狀態:', error)
      return null
    }
  }

  // 通知有更新可用
  notifyUpdate() {
    // 可以在這裡實現更新通知 UI
    const event = new CustomEvent('sw-update-available')
    window.dispatchEvent(event)
  }

  // 強制更新 Service Worker
  async forceUpdate() {
    if (this.registration && this.registration.waiting) {
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }
}

// 建立全域實例
const swManager = new ServiceWorkerManager()

// 自動註冊（在支援的環境）
if (typeof window !== 'undefined') {
  // 在 HTTPS 或 localhost 環境下註冊
  if (window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
    swManager.register().catch(console.error)
  }
}

export default swManager